import MoveInDate from '../enums/moveInDate';
import PlanStatus from '../enums/planStatus';
import {
  getInventoryStatusCombination,
  hasAvailableNow,
  hasInventoryStatusCombination,
  hasReadyToBuild,
} from './homeStatusValidator';

/**
 * A function that verifies if move in date filters are applied.
 *
 * When the home status Available Now, Ready to Build or move in data range are applied
 * the move in date filter is applied. Otherwise false.
 */
function isMoveInDateApplied(selector) {
  const { homeStatus, moveInDateRange } = selector;
  // For All Quick Move In option.
  if (hasInventoryStatusCombination(homeStatus)) {
    return true;
  }

  // For Move Now option.
  if (hasAvailableNow(homeStatus)) {
    return true;
  }

  // For Buildable plans option.
  if (hasReadyToBuild(homeStatus)) {
    return true;
  }

  // For Move In date ranges options.
  if (
    moveInDateRange === MoveInDate.OneToTwoMonths.toString() ||
    moveInDateRange === MoveInDate.ThreeToSixMonths.toString()
  ) {
    return true;
  }

  return false;
}

/**
 * Gets the home status filter applied from the state.
 * @param {string} homeStatus The home status search parameter value.
 * @returns The type of home status filter applied if any.
 */
const getHomeStatusFilterApplied = (homeStatus) => {
  if (hasInventoryStatusCombination(homeStatus)) {
    return getInventoryStatusCombination();
  }

  if (hasAvailableNow(homeStatus)) {
    return PlanStatus.AvailableNow.toString();
  }

  if (hasReadyToBuild(homeStatus)) {
    return PlanStatus.ReadyToBuild.toString();
  }

  return '';
};

/**
 * Gets the move in date filter applied from the state.
 * @param {string} moveInDateRange The move in date range search parameter value.
 * @returns the move in date filter applied if any.
 */
const getMoveInDateFilterApplied = (moveInDateRange) => {
  switch (moveInDateRange) {
    case MoveInDate.OneToTwoMonths.toString():
      return MoveInDate.OneToTwoMonths.toString();
    case MoveInDate.ThreeToSixMonths.toString():
      return MoveInDate.ThreeToSixMonths.toString();
    case MoveInDate.BuildablePlans.toString():
      return MoveInDate.BuildablePlans.toString();
    default:
      return '';
  }
};

/**
 * Return the move in date filter applied according to home status or moveInDateRange search parameters.
 */
const getMovingDateFilterApplied = (parameters) => {
  const { homeStatus, moveInDateRange } = parameters;
  const homeStatusFilterApplied = getHomeStatusFilterApplied(homeStatus);

  if (homeStatusFilterApplied) {
    return homeStatusFilterApplied;
  }

  const moveInDateFilterApplied = getMoveInDateFilterApplied(moveInDateRange);
  if (moveInDateFilterApplied) {
    return moveInDateFilterApplied;
  }

  return '';
};

export { isMoveInDateApplied, getMovingDateFilterApplied, getHomeStatusFilterApplied };
